import React, {Component} from 'react';
import moment from "moment";
import NoteEdit from "./NoteEdit";

class Note extends Component{
    constructor(props){
        super(props);
        this.state = {
          edit: false
        };
    }
    editToggler(){
        this.setState({edit: !this.state.edit});
    }
    removeNote(){
        this.props.startLoading();
        this.props.removeNote(this.props.note.id);
    }
    render(){
        return(
            <div>
                {!this.state.edit ?
                <div className="alert alert-warning alert-dismissible fade show note" role="alert">
                    {this.props.note.text}
                    <hr />
                    <div className="mb-0">
                        <small><i className="fa fa-clock-o" /> {moment.parseZone(this.props.note.updated_at).local().locale('es').format('D [de] MMM YYYY[,] H:mm')}</small>
                        <div className="actions float-right">
                            <button
                                className="btn btn-link btn-warning"
                                onClick={this.editToggler.bind(this)}
                            >
                                <i className="fa fa-edit text-warning text-warning" />
                            </button>
                            <button
                                className="btn btn-link btn-warning"
                                onClick={this.removeNote.bind(this)}
                            >
                                <i className="fa fa-remove text-warning" />
                            </button>
                        </div>
                    </div>
                </div>
                    :
                 <NoteEdit
                     note={this.props.note}
                     cancel={this.editToggler.bind(this)}
                 />
                }

            </div>
        )
    }
}
export default Note;


// WEBPACK FOOTER //
// ./resources/assets/js/components/admin/notes/Note.jsx